module.exports = __webpack_public_path__ + "static/img/user1.73342b93.png";